import { connect } from "react-redux";
import { push } from "redux-little-router";

const InternalRedirect = ({ href = "/", actions }) => {
  actions.push(href);
  return null;
};

const mapDispatchToProps = dispatch => ({
  actions: {
    push: (...props) => dispatch(push(...props)),
  },
});

export default connect(null, mapDispatchToProps)(InternalRedirect);



// WEBPACK FOOTER //
// ./src/components/InternalRedirect/index.js